import React from 'react';
import { withRouter } from 'react-router-dom';
import { api_route, user_logout } from '../helpers/Global';
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';

class Profil extends React.Component {

    constructor(props) {
        super(props);
        var inputs = {};
        inputs['old_password'] = '';
        inputs['new_password'] = '';
        inputs['confirmed_password'] = '';
        this.state = {
            inputs: inputs,
            current_password: '',
        }
    }

    submit = () => {
        const inputs = this.state.inputs;
        let formData = new FormData();
        formData.append('old_password', inputs.old_password);
        formData.append('new_password', inputs.new_password);
        formData.append('confirmed_password', inputs.confirmed_password);
        fetch(api_route('update-password'), { method: 'POST', body: formData })
            .then(resp => resp.json())
            .then(resp => {
                if (resp.response === 'error-connected') {
                    user_logout();
                    this.props.history.push(`/user-logout`);
                    this.props.loaderDisplay(false);
                }
                if (resp.response === 'error') {
                    alertify.error(resp.message);
                } else if (resp.response === 'success') {
                    var inputs = {};
                    inputs['old_password'] = '';
                    inputs['new_password'] = '';
                    inputs['confirmed_password'] = '';
                    this.setState({ inputs: inputs }, function () {
                        alertify.success(resp.message);
                    });
                }
            })
           .catch(err => {
                this.props.loaderDisplay(false);
                this.props.openErrorSystem(true);
            })
    }

    render() {
        const inputs = this.state.inputs;

        return (
            <React.Fragment>
                <div className="row mb-4 bg-template-opacity">
                    <div className="container py-4">
                        <div className="row">
                            <div className="col">
                                <h5 className="font-weight-normal template-primary">Modifier mot de passe</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="container">
                        <div className="card shadow-sm border-0 mb-4">
                            <div className="card-header border-0 gradient-pink p-0">
                                <div className="row">
                                    <div className="col text-center py-4">
                                        <h3>Nouveau mot de passe</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row justify-content-center">
                                    <div className="col-12 col-md-10 col-xl-8 mx-auto">
                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Mot de passe actuel</label>
                                                <input type="password" name="old_password" className="form-control" onChange={this.inputHandling} value={inputs.old_password} />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Nouveau mot de passe</label>
                                                <input type="password" name="new_password" className="form-control" onChange={this.inputHandling} />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <div className=" col-md-12">
                                                <label>Confirmez votre nouveau mot de passe</label>
                                                <input type="password" name="confirmed_password" className="form-control" onChange={this.inputHandling} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <button className="btn btn-info float-right" onClick={() => this.submit()}>Valider</button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    inputHandling = (event) => {
        const target = event.target;
        const inputs = this.state.inputs;
        inputs[target.name] = target.value;
        this.setState({ inputs: inputs });
    }

}

export default withRouter(Profil);